import { render, staticRenderFns } from "./ResultsList.vue?vue&type=template&id=8e5ed8ac&scoped=true&lang=pug&"
import script from "./ResultsList.vue?vue&type=script&lang=js&"
export * from "./ResultsList.vue?vue&type=script&lang=js&"
import style0 from "./ResultsList.vue?vue&type=style&index=0&id=8e5ed8ac&lang=scss&scoped=true&"
import style1 from "./ResultsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5ed8ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VDataTable,VPagination})
